<template>
  <div class="col-12 col-md-7">
    <div class="mid-container-small">
      <NavMenu/>
      <main class="content">
          <div class="row">
            <div class="col-12">
              <div class="tittle-content">
                <img class="subtittle-img" src="../assets/img/proyectos.webp" alt="Da vida a tus proyectos">
                <p class="subtittle-text">Escoge tu vía de financiamiento</p>
              </div>
            </div>
            <div class="col-12 col-md-10">
              <p class="general-text">En Financiera Sihusel, comprendemos que tu proyecto tiene infinitas posibilidades. Por eso, hemos creado una variedad de alternativas financieras específicamente diseñadas para ayudarte a convertirlas en realidad. Tu visión merece el respaldo adecuado, y estamos aquí para brindarte las soluciones financieras que necesitas.</p>
            </div>
          </div>
      </main>
      <div class="d-none d-md-block"><FooterSihusel/></div>
    </div>
  </div>
  <div class="col-12 col-md-4">
    <div class="right-container">
      <div class="row row-card">
        <div class="col-6 col-display">
            <div class="card-container">
              <router-link to="/Creditos/Persona-Fisica"><img class="img-card credito-1" src="../assets/img/credito-1.webp"></router-link>
            </div>
        </div>
        <div class="col-6 col-display">
            <div class="card-container">
              <router-link to="/Creditos/Obligado-Solidario"><img class="img-card credito-2" src="../assets/img/credito-2.webp"></router-link>
            </div>
        </div>
        <div class="col-3 col-md-6 col-display">
            <!-- <div class="card-container">
              <router-link to="/Creditos"><img class="img-card credito-3" src="../assets/img/credito-3.webp"></router-link>
            </div> -->
        </div>
        <div class="col-6 col-display">
            <div class="card-container">
              <router-link to="/Creditos/Garantia-Fiduciaria"><img class="img-card credito-4" src="../assets/img/credito-4.webp"></router-link>
            </div>
        </div>
      </div>
    </div>
    <div class="d-block d-md-none"><FooterSihusel/></div>
  </div>
</template>

<script>
import FooterSihusel from './FooterSihusel.vue';
import NavMenu from './NavMenu.vue';

export default {
  name: 'NosotrosComponent',
  components: {
    NavMenu,
    FooterSihusel
  }
}
</script>

